var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQueueRedirected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54029 5.13377C6.77617 4.93409 7.13079 4.96103 7.33296 5.19399C7.53514 5.42695 7.50786 5.77719 7.27199 5.97687L5.7641 7.25291L7.30385 8.77364C7.52352 8.9906 7.52352 9.34227 7.30385 9.55923C7.08418 9.77619 6.7281 9.77619 6.50843 9.55923L4.53966 7.61478C4.4289 7.5054 4.36944 7.35541 4.37541 7.20083C4.38142 7.0462 4.45256 6.90115 4.57152 6.80044L6.54029 5.13377Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4047 6.66406C13.6426 6.66408 15.5347 8.46085 15.6218 10.6701C15.7142 13.0055 13.7687 14.9974 11.4047 14.9974H6.62448C6.31381 14.9974 6.06197 14.7487 6.06197 14.4418C6.06197 14.135 6.31381 13.8863 6.62448 13.8863H11.4047C13.1318 13.8863 14.5653 12.4171 14.4979 10.7135C14.4343 9.10067 13.0384 7.7752 11.4047 7.77517H4.93751C4.62684 7.77517 4.375 7.52644 4.375 7.21962C4.375 6.91279 4.62684 6.66406 4.93751 6.66406H11.4047Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueRedirected);
export default __webpack_public_path__ + "static/media/QueueRedirected.c135e26300c1b47a7af6de0d7de74488.svg";
export { ForwardRef as ReactComponent };